<app-tiny-mce-editor [ctrl]="ctrl" [options]="editorOptions" [disabled]="disabled"></app-tiny-mce-editor>
